(function () {
  window.formatEffiloMoney = function (cents) {
    if (cents == null || isNaN(cents)) return '';

    var rupees = Number(cents) / 100;
    var rounded = Math.round(rupees * 100) / 100;
    var hasFraction = Math.abs(rounded - Math.round(rounded)) > 0.001;

    if (hasFraction) {
      return (
        '₹' +
        rounded
          .toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          .replace(/\.00$/, '')
      );
    }

    return '₹' + Math.round(rounded).toLocaleString('en-IN');
  };
})();
